import { InjectionToken } from '@angular/core';
import { IWhiteLabelConfig } from '../interfaces/white-label-config.interface';

export const WHITE_LABEL_CONFIG = new InjectionToken<IWhiteLabelConfig>('white-label-config');
